import BaseService from '../base';

class VehicleCategory extends BaseService {}

export default new VehicleCategory('vehicle-categories', 'VehicleCategory');
